import { render } from "./LotteryHistory.vue?vue&type=template&id=f3ef2b88&scoped=true"
import script from "./LotteryHistory.vue?vue&type=script&lang=js"
export * from "./LotteryHistory.vue?vue&type=script&lang=js"

import "./LotteryHistory.vue?vue&type=style&index=0&id=f3ef2b88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ef2b88"]])

export default __exports__